import React, { createElement, PureComponent } from 'react';
import { message as AntMessage, Modal as AntModal, Upload as AntUpload } from 'antd';
import { interpolate } from '@comall-backend-builder/core/lib/services';
import { ButtonProps, Button } from '@comall-backend-builder/components-basis/lib/button';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { UploadProps } from 'antd/lib/upload';

/**
 * 导入功能
 *  @param {Object} buttons -  参照buttons组件配置
 *  @param {String} apiRoot -  接口的根路径
 *  @param {String} action -   接口的根相对路径
 *  @param {Number} maxSize -  导入文件大小限制
 *  @param {String} successTitle -  导入成功时modal的title
 *  @param {String} successContent -  导入成功时modal的content
 *  @param {String} failTitle -  导入失败时modal的title
 *  @param {Boolean} disabled -  按钮启用、禁用状态
 *  @param {Boolean} refresh -  导入成功后是否刷新页面
 *  其他配置参照antd的Upload组件配置
 */

export interface UploadButtonProps extends UploadProps {
    buttons: ButtonProps;
    apiRoot: string;
    action: string;
    maxSize?: number;
    successTitle: string;
    successContent?: string;
    failTitle: string;
    disabled?: boolean;
    refresh?: boolean;
    responseMessage?: boolean;
    entity?: Entity | undefined;
    params?: any;
    successBehavior?: any;
    isDropdownWidth?: number; // 如果是在Dropdown使用必传，具体展示宽度
}

interface UploadButtonState {
    loading: boolean;
    fileList: any[];
}

export class UploadButton extends PureComponent<UploadButtonProps, UploadButtonState> {
    static defaultProps = {
        showUploadList: false,
        responseMessage: true,
        name: 'file',
        maxSize: 2048,
        buttons: {
            text: '导入',
        },
        apiRoot: ENV.API_ROOT,
    };
    /**
     * 默认的上传处理,成功后触发外部回调
     * @param info
     */
    onChange = (info: any) => {
        const {
            responseMessage,
            refresh,
            entity,
            params,
            successTitle,
            successContent,
            failTitle,
            successBehavior,
        } = this.props;
        if (info.file.status === 'uploading') {
            this.setState({
                loading: true,
            });
        }
        if (info.file.status === 'done') {
            const {
                file: { response },
            } = info;
            successBehavior && successBehavior.bind(this)(response);
            let message = successContent;
            if (typeof response === 'string') {
                message = response;
            } else {
                message = interpolate(message, { result: response });
            }
            responseMessage &&
                AntModal.success({
                    title: successTitle,
                    content: message,
                });
            this.setState({
                loading: false,
            });
            if (refresh) {
                entity.search(params);
            }
        }
        if (info.file.status === 'error') {
            const {
                file: { response },
            } = info;
            let message = '上传失败';
            if (response && response.err_msg) {
                message = response.err_msg;
            }
            responseMessage &&
                AntModal.error({
                    title: failTitle,
                    content: message,
                });
            this.setState({
                loading: false,
            });
        }
    };
    /**
     * 上传前校验文件大小
     * @param file
     * @returns {boolean}
     */
    beforeUpload = (file: any) => {
        const { maxSize } = this.props;
        if (maxSize && file.size > maxSize * 1024) {
            AntMessage.error('上传文件大小不能超过 ' + maxSize + 'KB');
            return false;
        }
        return !this.state.loading;
    };

    constructor(props: UploadButtonProps) {
        super(props);
        this.state = {
            loading: false,
            fileList: [],
        };
    }

    render() {
        let {
            action,
            data,
            buttons,
            params,
            disabled,
            accept,
            apiRoot = ENV.API_ROOT,
            isDropdownWidth,
        } = this.props;
        let context = {
            params,
        };
        action = interpolate(action, context);
        const { loading } = this.state;
        let props = {
            ...this.props,
            beforeUpload: this.beforeUpload,
            action: apiRoot + action,
            data,
            accept,
            disabled: loading,
        };
        let children = null;
        const dropdownLinkWidth = isDropdownWidth || 110;
        children = (
            <div>
                {isDropdownWidth ? (
                    <Button
                        style={{
                            display: 'block',
                            height: '30px',
                            width: `${dropdownLinkWidth}px`,
                            textAlign: 'center',
                            lineHeight: '30px',
                        }}
                        {...buttons}
                        type="link"
                        disabled={disabled}
                        icon={loading ? 'loading' : buttons.icon}
                    />
                ) : (
                    <Button
                        {...buttons}
                        disabled={disabled}
                        icon={loading ? 'loading' : buttons.icon}
                    >
                        {buttons.text}
                    </Button>
                )}
            </div>
        );

        //如果是非可编辑状态的话，不显示上传按钮
        return createElement(
            AntUpload,
            {
                ...props,
                onChange: this.onChange,
            },
            children
        );
    }
}
